<template>
  <component
    :is="componentData.component"
    v-model="filters"
    v-bind="componentData.attrs"
    class="helmi-search-watch-filter"
    content-class="helmi-search-watch-filter"
  >
    <v-row class="py-0 px-2 ma-0 white">
      <v-col class="pa-0" cols="12">
        <v-list dense>
          <v-list-item class="pa-0 px-sm-2">
            <v-list-item-avatar class="mr-2">
              <v-icon color="primary">
                search
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Hakuvahdin kriteerit</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action class="py-0 my-0">
              <v-btn
                outlined
                small
                color="primary"
                @click="resetFilters"
              >
                <v-icon left>
                  delete
                </v-icon>
                Tyhjennä
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>

      <v-col class="py-0">
        <v-divider class="mx-n5" style="max-width: calc(100% + 40px);"/>
      </v-col>
      <v-col class="pa-0" cols="12">
        <v-form ref="searchForm">
          <helmi-chips
            id="target_type"
            v-model="items.target_type"
            :container-options="{
              cols: 12,
              class: 'py-1',
            }"
            :options="targetTypes"
            :colors="colors"
            :label-colors="labelColors"
            icon="rule"
            label="Kohde"
          />

          <helmi-chips
            id="propertyType"
            v-model="items.property_types"
            :container-options="{
              cols: 12,
              class: 'py-1',
            }"
            :options="propertyTypes"
            :additional-options="additionalPropertyTypes"
            :colors="colors"
            :label-colors="labelColors"
            icon="home_work"
            label="Kohdetyyppi"
            label-additional-options="Muut kohdetyypit"
            multiple
          />

          <helmi-combo-box
            id="cities"
            v-model="items.cities"
            :container-options="{
              cols: 12,
              class: 'py-1',
            }"
            :colors="colors"
            :label-colors="labelColors"
            icon="place"
            label="Kaupunki tai postinumero"
            multiple
          />

          <helmi-range-slider
            id="rooms"
            v-model="items.rooms"
            :container-options="{
              cols: 12,
              class: 'py-1',
            }"
            :colors="colors"
            :label-colors="labelColors"
            icon="room_preferences"
            label="Huoneluku"
            min="0"
            max="10"
            suffix="kpl"
            step="1"
          />

          <helmi-range-slider
            id="area"
            v-model="items.area"
            :container-options="{
              cols: 12,
              class: 'py-1',
            }"
            :colors="colors"
            :label-colors="labelColors"
            icon="square_foot"
            label="Pinta-ala"
            min="0"
            max="500"
            suffix="m2"
            step="10"
          />

          <helmi-range-slider
            id="price"
            v-model="items.price"
            :container-options="{
              cols: 12,
              class: 'py-1',
            }"
            :colors="colors"
            :label-colors="labelColors"
            :max="maxPrice"
            :step="stepPrice"
            :step-options="stepOptionsPrice"
            icon="money"
            label="Hinta"
            min="0"
            suffix="€"
          />

          <helmi-chips
            id="requirements"
            v-model="items.requirements"
            :container-options="{
              cols: 12,
              class: 'py-1',
            }"
            :options="requirements"
            :colors="colors"
            :label-colors="labelColors"
            icon="hot_tub"
            label="Pitää olla"
            multiple
          />

          <v-card-actions style="width: 100%">
            <v-spacer/>
            <v-btn
              v-if="!showSingleButton"
              color="accent"
              text
              @click="filters = !filters"
            >
              Sulje
            </v-btn>
            <v-btn
              id="submit"
              color="primary"
              :block="showSingleButton"
              :class="showSingleButton ? 'mt-2' : null"
              :disabled="notarget_type"
              @click="create = true;"
            >
              Tallenna hakuvahdiksi
            </v-btn>
          </v-card-actions>

          <helmi-search-watch-create-dialog
            id="customerDialog"
            color="primary"
            :show="create"
            :customer="customer"
            @close="create = false;"
            @save="createNewSearchWatch"
          />
        </v-form>
      </v-col>
    </v-row>
  </component>
</template>

<script>
import debounce from 'lodash.debounce';
import { mapActions } from 'vuex';
import { isAnObject, EventBus } from '@/utils';

export default {
  name: 'HelmiSearchWatchFilter',

  components: {
    'helmi-chips': () => import('@/components/formElements/Chips'),
    'helmi-range-slider': () => import('@/components/formElements/RangeSlider'),
    'helmi-combo-box': () => import('@/components/formElements/ComboBox'),
    'helmi-search-watch-create-dialog': () => import('@/components/searchWatch/SearchWatchCreateDialog'),
    VBottomSheet: () => import('vuetify/lib/components/VBottomSheet'),
    VNavigationDrawer: () => import('vuetify/lib/components/VNavigationDrawer'),
  },

  props: {
    items: {
      type: Object,
      default: () => ({}),
    },

    additionalPropertyTypes: {
      type: Array,
      default: () => [],
    },

    requirements: {
      type: Array,
      default: () => [],
    },

    propertyTypes: {
      type: Array,
      default: () => [],
    },

    targetTypes: {
      type: Array,
      default: () => [],
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    customer: {
      type: Object,
      default: () => ({}),
    },

    labelColors: {
      type: Object,
      default: () => null,
    },
  },

  data: () => ({
    create: false,
    filters: false,
  }),

  computed: {
    notarget_type() {
      return this.items.target_type !== 'sales' && this.items.target_type !== 'rental';
    },

    companyId() {
      return this.$route.params.companyId;
    },

    componentData() {
      const component = this.$vuetify.breakpoint.mdAndDown
        ? 'v-bottom-sheet'
        : 'v-navigation-drawer';

      const attrs = {
        'v-bottom-sheet': {},
        'v-navigation-drawer': {
          app: true,
          clipped: true,
          fixed: true,
          permanent: true,
          right: true,
          width: 460,
        },
      };

      return {
        component,
        attrs: {
          ...attrs[component],
        },
      };
    },

    maxPrice() {
      return this.items.target_type === 'rental' ? 5000 : 1000000;
    },

    showSingleButton() {
      return this.$vuetify.breakpoint.lgAndUp;
    },

    stepOptionsPrice() {
      return this.items.target_type === 'rental'
        ? { limit: 1000, step: [10, 50] }
        : { limit: 200000, step: [10000, 50000] };
    },

    stepPrice() {
      return this.items.target_type === 'rental' ? 50 : 10000;
    },
  },

  watch: {
    items: {
      handler(items) {
        EventBus.$emit('SEARCH_WATCH_FILTERS_CHANGED', items);
        this.$emit('loading', true);
        this.filterItems();
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    EventBus.$on('SHOW_FILTERS', this.showFilters);
  },

  methods: {
    ...mapActions({
      getWatches: 'searchWatch/get',
    }),

    async createNewSearchWatch() {
      await this.$emit('save', {
        items: this.items,
        customer: this.customer,
        companyId: this.companyId,
      });
      this.showFilters();
      this.create = false;
      this.filterItems();
    },

    filterItems: debounce(async function () { // eslint-disable-line
      try {
        const params = Object.entries(this.items)
          .reduce((items, [key, item]) => {
            if (isAnObject(item)) {
              // eslint-disable-next-line no-param-reassign
              items = { ...items, ...item };
              return items;
            }
            // eslint-disable-next-line no-param-reassign
            items[key] = item;
            return items;
          }, {});

        await this.getWatches({
          ...params,
          companyId: this.companyId,
          // personId: 1,
          active: true,
        });
        this.$emit('loading', false);
      } catch (error) {
        console.error(error);
        this.$emit('loading', false);
      }
    }, 500),

    resetFilters() {
      EventBus.$emit('FORM_RESET');
    },

    showFilters() {
      this.filters = !this.filters;
    },
  },
};
</script>

<style lang="scss">
.helmi-search-watch {
  &-filter {
    overflow: auto !important;
  }

  .v-btn--fab {
    z-index: 203 !important;
  }
}
</style>
